import { SignalR, ConnectionTransports } from 'ng2-signalr';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { NotificationModel, ClearNotificationModel } from '../models/SignalrModel';
import { BuyerInformationModel } from '../modules/dashboard/buyer-upload-section/Models/BuyerInformationModel';

@Injectable()
export class SignalRService {
    public _connectionNotificationHub: any;
    public _connectionPrismUserHub: any;
    public messagesCount$: Subject<number>;
    public updateData$: BehaviorSubject<number>;
    public notificationData$: BehaviorSubject<NotificationModel>;
    public updateMailNotification$: BehaviorSubject<BuyerInformationModel>;
    public removeNotificationData$: BehaviorSubject<NotificationModel>;
    public clearNotification$: BehaviorSubject<ClearNotificationModel>;
    public refreshGrids$: BehaviorSubject<number>;

    constructor(private _signalR: SignalR) {
        // this.messagesCount$ = new Subject<number>();
        this.updateData$ = new BehaviorSubject<number>(0);
        this.updateMailNotification$ = new BehaviorSubject<BuyerInformationModel>(undefined);
        this.notificationData$ = new BehaviorSubject<NotificationModel>(undefined);
        this.removeNotificationData$ = new BehaviorSubject<NotificationModel>(undefined);
        this.clearNotification$ = new BehaviorSubject<ClearNotificationModel>(undefined);
        this.refreshGrids$ = new BehaviorSubject<number>(undefined);
    }

    private createHubConnection(hubName: string, qsParams: any) {
        return this._signalR.connect({
            hubName: hubName,
            qs: qsParams,
            url: environment.origin,
            transport: [ConnectionTransports.webSockets, ConnectionTransports.longPolling]
        });
    }

    async resolve(buyerId: number) {
        if (buyerId > 0) {
            if (!this._connectionNotificationHub) {
                this.createHubConnection('NotificationHub', { 'buyerId': buyerId }).then((res) => {
                    this._connectionNotificationHub = res;
                    let clientNotificationListener = this._connectionNotificationHub.listenFor('SendNotification');
                    clientNotificationListener.subscribe((response: NotificationModel) => {
                        if (response) {
                            this.notificationData$.next(response);
                        }
                    });
                    let clientRemoveNotificationListener = this._connectionNotificationHub.listenFor('RemoveFromNotificationList');
                    clientRemoveNotificationListener.subscribe((response: NotificationModel) => {
                        if (response) {
                            this.removeNotificationData$.next(response);
                        }
                    });
                    return true;
                });
            }
        } else {
            this.createHubConnection('PrismUserHub', {}).then((res) => {
                this._connectionPrismUserHub = res;
                let clientMailNotificationListener = this._connectionPrismUserHub.listenFor('SendMailNotification');
                clientMailNotificationListener.subscribe((response: BuyerInformationModel) => {
                    if (response) {
                        this.updateMailNotification$.next(response);
                    }
                });
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/services/signalr.service.ts